import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { bgBlur } from '../../theme/css';
import { NAV, HEADER } from './config-layout';
import Iconify from '../../components/iconify';
import AccountPopover from './common/account-popover';
import { useResponsive } from '../../hooks/use-responsive';

// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {
  const theme = useTheme();
  const user = useSelector((state) => state.auth.user); // Get user from Redux store
  const upCustom = useResponsive('up', 1400); // Match the nav collapse breakpoint

  const renderContent = (
    <>
      {!upCustom && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'white'}}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}

      <Box sx={{ flexGrow: 1 }} />

      {/* User Info & Account Popover */}
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            bgcolor: alpha(theme.palette.grey[500], 0.12),
            py: 1,
            px: 2,
            borderRadius: 1.5,
          }}
        >
          <Typography variant="body1" sx={{ color: '#ffffff', ml: 1 }}>
            {user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff', ml: 1 }}>
            {user?.role}
          </Typography>
        </Box>
        <AccountPopover /> {/* ✅ Re-added the account popover */}
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        background: 'linear-gradient(135deg, #e60000 -0%, #692246 100%)',
        color: '#ffffff',
        transition: theme.transitions.create(['height', 'width'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(upCustom && {
          width: `calc(100% - ${NAV.WIDTH}px)`, // Adjust width when nav is visible
          height: HEADER.H_DESKTOP,
        }),
        ...(!upCustom && {
          width: '100%', // Expand header when nav is collapsed
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
